const LootSpawnEvent = function (battleState) {
  this.eventHandle = 'loot_spawn';

  this.execute = (tileId, tile_loot) => {
    const tile = battleState.allTiles[tileId];
    if (!tile) {
      throw new Error(`Tile ${tileId} not found`);
    }
    tile.loot = tile_loot;
    this.tileId = tile.uid;
    this.tile = tile;
    this.affectedPieces = [tile];
    battleState.onBattleEvent(this);
  };
};
module.exports = LootSpawnEvent;
